import { useTranslation } from 'react-i18next'

import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts'

import DashboardCard from '../DashboardCard'
import styles from './DataInTeaser.module.scss'

// Illustrative values only; this teaser does not represent workspace activity.
const sampleData = [
  { month: 'JAN', events: 6000 },
  { month: 'FEB', events: 5400 },
  { month: 'MAR', events: 6900 },
  { month: 'APR', events: 6900 },
  { month: 'MAY', events: 6000 },
  { month: 'JUN', events: 5000 },
  { month: 'JUL', events: 4000 },
  { month: 'AUG', events: 3000 },
  { month: 'SEP', events: 3200 },
  { month: 'OCT', events: 5000 },
  { month: 'NOV', events: 6000 },
  { month: 'DEC', events: 7000 },
]

const DataInTeaser = () => {
  const { t } = useTranslation('dashboard')

  return (
    <DashboardCard comingSoon title={t('tiles.dataIn.title')}>
      <div className={styles.preview}>
        <div className={styles.summary}>
          <strong>3,667</strong>
          <span>{t('tiles.dataIn.eventsReceived')}</span>
        </div>
        <div className={styles.chart}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={sampleData} margin={{ top: 8, right: 0, bottom: 0, left: 0 }}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="month" axisLine={false} tickLine={false} minTickGap={20} />
              <YAxis
                domain={[0, 8000]}
                axisLine={false}
                tickLine={false}
                width={32}
                tickFormatter={(value: number) => (value ? `${value / 1000}K` : '0')}
              />
              <Area
                className={styles.area}
                dataKey="events"
                type="monotone"
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </DashboardCard>
  )
}

export default DataInTeaser
